import { Link } from 'react-router-dom';

function PageNotFoundPage() {
	return (
		<div>
			<h1 style={{ textAlign: 'center' }}>
				Page Not found!
			</h1>

			<Link to="/">
				<p style={{ textAlign: 'center' }}>
					Click here to return to homepage
				</p>
			</Link>
		</div>
	);
}

export default PageNotFoundPage;
